import { createSlice } from "@reduxjs/toolkit";

const scrollSlice = createSlice({
  name: "scroll",
  initialState: {
    targetComponent: null,
    /** Sidebar section last clicked; used so P&L can refresh on enter and reset (close Itemized P&L) on leave */
    activeSection: null,
  },
  reducers: {
    setScrollTarget: (state, action) => {
      state.targetComponent = action.payload;
    },
    clearScrollTarget: (state) => {
      state.targetComponent = null;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
  },
});

export const { setScrollTarget, clearScrollTarget, setActiveSection } = scrollSlice.actions;
export default scrollSlice.reducer;
